import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';

export interface IFifthWheelConnection {
  id?: number;
  created?: string | null;
  installVehicleOdometer?: number | null;
  installTrailerOdometer?: number | null;
  vehicle?: ITruckImplement | null;
  trailer?: ITruckImplement | null;
  company?: ICompany | null;
  vehiclePosition?: IVehiclePosition | null;
}

export const defaultValue: Readonly<IFifthWheelConnection> = {};
